import React, { createContext, useContext } from 'react';
export const BADGE_SIZES = ['md', 'lg'];
export const BADGE_VARIANTS = ['primary', 'secondary'];
const BadgeContext = createContext(undefined);
export const BadgeProvider = ({ variant, size, children }) => (React.createElement(BadgeContext.Provider, { value: {
        variant,
        size,
    } }, children));
export const useBadge = () => {
    const context = useContext(BadgeContext);
    if (context === undefined) {
        throw new Error('useBadge must be used within a BadgeProvider');
    }
    return context;
};
//# sourceMappingURL=BadgeContext.js.map